const HEADER_KEYWORDS = [
  "Article",
  "Section",
  String.raw`Sec\.`,
  "Clause",
  "Subclause",
  "Paragraph",
  String.raw`Para\.`,
  "Subparagraph",
  "Chapter",
  "Part",
  "Subpart",
  "Division",
  "Provision",
  "Schedule",
  "Appendix",
  String.raw`App\.`,
  "Annex",
  String.raw`Ann\.`,
  "Exhibit",
  "Addendum",
  "Rider",
  "Attachment",
  "Item",
  "Subsection",
  String.raw`Subsec\.`,
  "Point",
  "Heading",
  "Rule",
  "Regulation",
  "Statement",
];

const HEADER_NUMBER_PATTERN = new RegExp(
  String.raw`^\s*(?:${HEADER_KEYWORDS.join("|")})\s+[\da-zA-Z]+(?:[.\da-zA-Z]*)?[.:]?\s*`,
  "im",
);

const HEADER_NUMBER_PATTERNS = [HEADER_NUMBER_PATTERN];

const ROMAN_HUNDREDS = String.raw`(?:C[MD]|D?C{0,3})`;
const ROMAN_TENS = String.raw`(?:X[CL]|L?X{0,3})`;
const ROMAN_UNITS = String.raw`(?:I[XV]|V?I{0,3})`;

const CLAUSE_NUMBER_PATTERNS = [
  new RegExp(String.raw`^#\s*M{0,4}${ROMAN_HUNDREDS}${ROMAN_TENS}${ROMAN_UNITS}\s+`, "im"),
  /^#\s*\d+\.\d+\.\d+\.\s*/m,
  /^#\s*\d+\.\d+\.\d+\s*/m,
  /^#\s*\d+\.\d+\.\s*/m,
  /^#\s*\d+\.\d+\s*/m,
  /^#\s*\d+\.\s*/m,
  /^#\s*\d+\s*/m,
  /^#\s*\d+[a-z]+\.\s*/im,
  /^#\s*\([a-z]\)\s*/im,
  /^[ \t]*\d+\.\d+\.\d+\.[ \t]*/m,
  /^[ \t]*\d+\.\d+\.\d+[ \t]*/m,
  /^[ \t]*\d+\.\d+\.[ \t]*/m,
  /^[ \t]*\d+\.\d+[ \t]*/m,
  /^[ \t]*\d+\.[ \t]*/m,
  /^[ \t]*\d+[ \t]*/m,
  /^[ \t]*[a-z]+\.[ \t]*/im,
  /^[ \t]*\d+[a-z]+\.[ \t]*/im,
  /^[ \t]*\([a-z]+\)[ \t]*/im,
];

export const BOLD_PREFIX_PATTERNS = [...HEADER_NUMBER_PATTERNS, ...CLAUSE_NUMBER_PATTERNS];
